//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import QCarousel from 'quasar/src/components/carousel/QCarousel.js';import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';;
import RequestInfoDialog from 'src/components/RequestInfoDialog';
export default {
  name: 'Typology',
  components: {
    QCarousel: QCarousel,
    QCarouselSlide: QCarouselSlide,
    QCarouselControl: QCarouselControl,
    RequestInfoDialog: RequestInfoDialog
  },
  props: ['typology'],
  data: function data() {
    return {
      showText: false,
      showRequestInfoDialog: false,
      showingImages: false,
      slide: 1,
      fullscreen: false
    };
  },
  computed: {
    isGrid: function isGrid() {
      return this.renderStyle === 'grid';
    },
    isList: function isList() {
      return this.renderStyle === 'list';
    }
  },
  methods: {
    toggleFullScreen: function toggleFullScreen() {
      this.fullscreen = !this.fullscreen;
      this.$refs.myTypology.$el.focus();
    },
    toggleText: function toggleText() {
      this.showText = !this.showText;
    },
    showDetail: function showDetail() {
      if (!this.typology.sold) {
        this.showingImages = true;
      }
    }
  }
};